export const INIT = '@account/init';
export const DISPOSE = '@account/dispose';
export const CREATE = '@account/create';
export const REMOVE = '@account/remove';
export const UPDATE = '@account/update';
export const CHANGE_VISIBILITY = '@account/change-visibility';
export const SET_BALANCE = '@account/set-balance';
export const SET_NONCE = '@account/set-nonce';
export const UPDATE_SELECTED_ACCOUNT = '@account/update-selected-account';
